import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import authActions from '../../auth/authActions';
import policyActions from '../../policy/policyActions';

import { Redirect } from 'react-router-dom';
import WorkflowStep from '../WorkflowStep';
import FieldSet from '../../components/forms/Fieldset';
import Utils from '../../common/utils';
import * as moment from 'moment';

interface Props {
	actions?: any;
	currentUser: UserDetails; // keep in mind that currentUser is just for checking auth status
	user: UserDetails;
	customerPolicy: CustomerPolicy;
	hidden: boolean;
	history?: any;
	match?: any;
}
class SignUpPage extends React.Component<Props> {

	componentDidMount() {
		this.props.actions.fetchCustomerPolicyFreeTrialMonths(this.props.user.id, this.props.customerPolicy.id);
	}

	componentWillUnmount() {
		this.props.actions.resetCustomerPolicy();
	}

	signUp = () => {
		this.props.actions.signUp();
	}

	renderSignUp = () => {
		const { customerPolicy } = this.props;
		return (
			<WorkflowStep title="Congratulations! You just purchased life insurance!">
				<div className="content-set">
					<FieldSet>
						<p>
							Your&nbsp;
							<span className="strong text-secondary">
								{Utils.formatCurrency(customerPolicy!.coverageAmount, 0)}
							</span> policy begins on&nbsp;
							<span className="strong text-secondary">
								{Utils.formatDateAsUTC(customerPolicy!.effectiveDate, 'MMMM D, YYYY')} 
							</span> and will be in place for&nbsp;
							<span className="strong text-secondary">
								{customerPolicy!.term}
							</span> years.
						</p>
						{customerPolicy.freeMonthTrial === 0 ?
						<p>
							Your first monthly payment of&nbsp;
							<span className="strong text-secondary">
								{Utils.formatCurrency(customerPolicy!.rate, 2)}
							</span> has been sucessfully processed.
						</p> :
						<p>
							The first <span className="strong text-secondary">
									{customerPolicy.freeMonthTrial}
								</span> {customerPolicy.freeMonthTrial! > 1 ? 'months' : 'month'} of your policy will
							be <span className="strong text-secondary">free</span> and your first monthly payment of&nbsp;
							<span className="strong text-secondary">
								{Utils.formatCurrency(customerPolicy!.rate, 2)}
							</span> will be processed on <span className="strong text-secondary">
								{moment(customerPolicy.effectiveDate).add(customerPolicy.freeMonthTrial, 'M').utc().format('MMMM D, YYYY')} 
							</span>.
						</p>
						}
						<p>
							Please check your e-mail for a link to your Mosaic Life online account, where you can review your 
							coverages. Also, don't forget to set up your beneficiaries if you skipped
							it in previous section.
						</p>
					</FieldSet>
				</div>
			</WorkflowStep>
		);
	}
	renderRedirect = () => {
		// make sure reset questionnaire before redirect, to ensure user won't be able to go back to existing policy
		this.props.actions.resetQuestionnaire();
		return (
			<Redirect to="/user/dashboard" />
		);
	}

	render() {
		const display = this.props.currentUser.isAuthenticated ? this.renderRedirect() : this.renderSignUp();
		return display;
	}
}
function mapStateToProps(state: any) {
	return {
		currentUser: state.auth.currentUser,
		user: state.user.user
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions, ...policyActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
export default connect(mapStateToProps, mapDispatchToProps)(SignUpPage as any);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/enrollment/SignUpPage.tsx